import React from "react";
import AddEditVerifiedCompetency from "../../features/VerifiedCompetency/AddEditVerifiedCompetency";

const AddVerifiedCompetency = () =>
{
  return (
    <>
      <AddEditVerifiedCompetency />
    </>
  );
};

export default AddVerifiedCompetency;
